module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"Text"},"fr":{"text":"Texte"}}')
  delete Component.options._Ctor
}
